import { Add as AddIcon, DeleteOutline as DeleteIcon } from '@mui/icons-material';
import Box, { BoxProps } from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { TransitionGroup } from 'react-transition-group';
import { ISimpleFieldTypes, ISortMultiRowInputsItems } from './FieldTypes';
import SimpleFieldRenderer, { ISimpleFieldRendererProps } from './SimpleFieldRenderer';
import { getFullNameOfField, getValuesFromProps, ISupportedValueType } from './utils';

export type ICallableRef = {
    setValues: (values: ISupportedValueType) => void;
};

const StyledTransitionGroup = styled(TransitionGroup)`
    width: 100%;
`;

type IProps = Pick<ISimpleFieldRendererProps, 'shouldUnregister' | 'readOnly' | 'fullWidth'> &
    ISortMultiRowInputsItems &
    Pick<BoxProps, 'sx'> & {
        fixedSize?: boolean;
        innerRef?: React.Ref<ICallableRef>;
        inputs: ISimpleFieldTypes[];
        name: string;
    };

const MultiRowGenerator = ({
    fixedSize = false,
    innerRef,
    inputs,
    name,
    shouldUnregister = false,
    sort,
    sx,
    ...rest
}: IProps) => {
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name,
        shouldUnregister
    });

    // React.useImperativeHandle(innerRef, () => ({
    //     setValues: () => {}
    // }));

    // if (sort && initialValues[name]) {
    //     sort(initialValues[name] as unknown as IValuesOfSimpleFields[]);
    // }

    const defaultsValues = getValuesFromProps(inputs);
    // const valuesFromInitial = initialValues[name];

    // React.useEffect(() => {
    //     if (!fixedSize) {
    //         if (fields.length === 0 && !isEmptyArray(initialValues[name])) {
    //             append(initialValues[name]);
    //         } else if (fields.length === 0) {
    //             append(defaultsValues);
    //         }
    //     }
    // }, []);
    // React.useEffect(() => {
    //     if (fixedSize) {
    //         if (fields.length === 0 && !isEmptyArray(valuesFromInitial)) {
    //             append(valuesFromInitial);
    //         }
    //     }
    // }, [fields.length, fixedSize, valuesFromInitial, append]);
    //
    // React.useEffect(() => {
    //     if (fixedSize) {
    //         if (fields.length === 0 && !isEmptyArray(valuesFromInitial)) {
    //             append(valuesFromInitial);
    //         }
    //     }
    // }, [fields.length, fixedSize, valuesFromInitial]);

    return (
        <StyledTransitionGroup data-testid={`multiRowForm-${name}`}>
            {fields.map((item, index) => (
                <Collapse key={`${name}-${item.id}`} in={true}>
                    {inputs.map((input) => (
                        <SimpleFieldRenderer
                            {...rest}
                            key={getFullNameOfField(input.props.name, name, index)}
                            input={input}
                            fullName={getFullNameOfField(input.props.name, name, index)}
                            parentName={getFullNameOfField('', name, index)}
                            rowIndex={index}
                        />
                    ))}
                    {index + 1 === fields.length && !fixedSize ? (
                        <SimpleFieldRenderer
                            {...rest}
                            key={`${name}-${index}-add`}
                            input={{
                                type: 'button',
                                width: 1,
                                props: {
                                    name: 'add',
                                    variant: 'text',
                                    children: <AddIcon />,
                                    color: 'primary',
                                    onClick: () => append(defaultsValues),
                                    sx: {
                                        p: 1,
                                        justifyContent: 'center'
                                    }
                                }
                            }}
                            fullName={getFullNameOfField('add', name, index)}
                        />
                    ) : (
                        <></>
                    )}
                    {fields.length > 1 && !fixedSize ? (
                        <SimpleFieldRenderer
                            {...rest}
                            key={`${name}-${index}-remove`}
                            input={{
                                type: 'button',
                                width: 1,
                                props: {
                                    name: 'remove',
                                    variant: 'text',
                                    children: <DeleteIcon spacing={0} />,
                                    color: 'error',
                                    onClick: () => remove(index),
                                    sx: {
                                        p: 1,
                                        justifyContent: 'center'
                                    }
                                }
                            }}
                            fullName={getFullNameOfField('remove', name, index)}
                        />
                    ) : (
                        <></>
                    )}
                    <Box key={`${name}-newLine-${index}`} sx={{ width: '100%' }} />
                </Collapse>
            ))}
        </StyledTransitionGroup>
    );
};

export default MultiRowGenerator;
